import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';
import { Image } from '../atoms/image'
import { Title } from '../atoms/title'

export const AlignerView = () =>
  <section className="content">
    <section className="content--standard alignerview">
      <Fade left cascade duration={500} delay={400} distance="40px">
        <Image imageName="double-aligner.png" className="alignerview--mainArea__image alignerview--mainArea__image__sp" />
      </Fade>
      <Title>ALIGNER</Title>
      <section className="alignerview--mainArea">
        <div className="alignerview--mainArea--descriptionArea">
          <Fade left duration={500} delay={400} distance="40px">
            <h3 className="alignerview--mainArea--descriptionArea__title">
              ソフトとハードの<br/>
              ダブルのアライナーを活用。
            </h3>
          </Fade>
          <Fade left duration={500} delay={400} distance="40px">
            <p className="alignerview--mainArea--descriptionArea__description">
            ソフトとハードのダブルのアライナーを活用し、快適さと移動効率の最大化の実現が可能
            </p>
          </Fade>
          <Fade left duration={500} delay={400} distance="40px">
            <section className="alignerview--detailArea">
              <div className="alignerview--detailArea--descriptionArea">
                <h4 className="alignerview--detailArea--descriptionArea__title">ソフト</h4>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>弾力性：889.3Mpa</strong>
                </div>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>厚み&emsp;：0.625mm</strong>
                </div>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>特徴</strong>
                  <p>
                    初めに矯正力の低いアライナーを装着することで、装着に対する痛みを軽減させることが可能です。
                  </p>
                </div>
              </div>
              <div className="alignerview--detailArea--descriptionArea">
                <h4 className="alignerview--detailArea--descriptionArea__title">ハード</h4>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>弾力性：1037Mpa</strong>
                </div>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>厚み&emsp;：0.75mm</strong>
                </div>
                <div className="alignerview--detailArea--descriptionArea--list">
                  <span>●</span>
                  <strong>特徴</strong>
                  <p>
                    αアライナーで歯牙の移動に対して痛みを軽減した後、弾性力の強いアライナーでより高い歯牙移動の正確性を確保します。
                  </p>
                </div>
              </div>
            </section>
          </Fade>
        </div>
        <Fade left cascade duration={500} delay={400} distance="40px">
          <Image imageName="double-aligner.png" className="alignerview--mainArea__image alignerview--mainArea__image__pc" />
        </Fade>
      </section>
    </section>
  </section>